import React, {FC, ReactNode, useState} from "react";
import {IconButton, InputBase} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import useStyles from "./styles";

type Props = {
  onChange: (value: string) => void;
  defaultValue?: string;
  className?: string;
  transparent?: boolean;
  placeholder?: string;
  icon?: ReactNode;
};

const SearchInput: FC<Props> = ({
  defaultValue,
  transparent,
  className,
  placeholder,
  icon,
  onChange,
}) => {
  const [value, setValue] = useState<string>(defaultValue || "");
  const classes = useStyles();

  const updateValue = (newValue: string) => {
    setValue(newValue);
    onChange(newValue);
  };

  return (
    <InputBase
      value={value}
      placeholder={placeholder || "Search..."}
      className={className}
      classes={{
        root: !transparent ? classes.searchInputRoot : undefined,
        focused: !transparent ? classes.searchInputFocused : undefined,
        input: classes.searchInputInput,
      }}
      startAdornment={icon ?? <SearchIcon className={classes.searchIcon} />}
      endAdornment={
        value ? (
          <IconButton
            aria-label="Clear search"
            className={classes.clearButton}
            onClick={() => updateValue("")}
          >
            <CloseIcon />
          </IconButton>
        ) : undefined
      }
      onChange={(event) => updateValue(event?.target?.value || "")}
    />
  );
};

export default SearchInput;
